(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('VerifytxSchedule', VerifytxSchedule);

    VerifytxSchedule.$inject = ['$resource'];

    function VerifytxSchedule ($resource) {
        var resourceUrl =  'api/verifytx-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByCorporation': {url: 'api/verifytx-schedules/corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
